<template>
  <v-dialog persistent v-model="showDialog" max-width="480">
    <v-card outlined v-if="!reset_success">
      <v-card-title>
        <span class="subtitle-1">Passwort ändern</span>
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid" ref="form">
          <v-text-field
            outlined
            v-model="oldPassword"
            v-if="!show_invalid_password_message"
            :append-icon="oldPasswordVisible ? 'visibility' : 'visibility_off'"
            @click:append="oldPasswordVisible = !oldPasswordVisible"
            :type="oldPasswordVisible ? 'text' : 'password'"
            label="altes Passwort"
            required
          />
          <v-alert outlined dismissible v-model="show_invalid_password_message" type="error">
            Eingegebenes Passwort stimmt nicht mit aktuellem Passwort überein.
          </v-alert>
          <v-text-field
            outlined
            v-model="newPassword"
            :append-icon="newPasswordVisible ? 'visibility' : 'visibility_off'"
            :rules="[
              passwordRules.required,
              passwordRules.mincnt,
              passwordRules.mincap,
              passwordRules.minnum,
              passwordRules.minspc,
            ]"
            :type="newPasswordVisible ? 'text' : 'password'"
            label="neues Passwort"
            @click:append="newPasswordVisible = !newPasswordVisible"
            required
          />
          <v-alert outlined dismissible v-model="show_limit_exceeded_message" type="error">
            Das Passwort wurde zu häufig geändert. Versuchen Sie es später noch einmal.
          </v-alert>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="discard">Abbrechen</v-btn>
        <v-btn text @click="accept" color="primary" :disabled="!valid">Passwort ändern</v-btn>
      </v-card-actions>
    </v-card>
    <v-card outlined v-if="reset_success">
      <v-card-title>
        <span class="subtitle-1">Passwort ändern</span>
      </v-card-title>
      <v-card-text>
        <span><v-icon color="green">check</v-icon></span>
        <span class="ml-3">Ihr Passwort wurde erfolgreich geändert.</span>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
function init_data() {
  return {
    valid: false,
    oldPassword: "",
    newPassword: "",
    oldPasswordVisible: false,
    newPasswordVisible: false,
    show_invalid_password_message: false,
    show_limit_exceeded_message: false,
    reset_success: false,
  };
}

export default {
  name: "ChangePasswordView",
  props: {
    showThis: Boolean,
  },
  watch: {
    showThis: function(st) {
      this.showDialog = st;
    },
    showDialog: function(show) {
      if (show === false) {
        this.$emit("discard");
      } else {
        this.reset_view();
      }
    },
  },
  computed: {
    passwordRules() {
      return {
        required: (value) => !!value || "Passwort ist ein Pflichtfeld",
        mincnt: (v) => v.length >= 8 || "Mindestens 8 Zeichen",
        mincap: (v) => /[A-Z]/.test(v) || "Mindestens 1 Großbuchstabe",
        minnum: (v) => /[0-9]/.test(v) || "Mindestens 1 Ziffer",
        minspc: (v) =>
          /[\^$*.\[\]{}()?"!@#%&/\\,><':;|_~`]/.test(v) ||
          "Mindestens 1 Sonderzeichen (^ $ * . [ ] { } ( ) ? \" ! @ # % & / \ , > < ' : ; | _ ~ `)",
      };
    },
  },
  methods: {
    reset_view() {
      Object.assign(this, init_data());
    },
    discard() {
      this.showDialog = false;
    },
    accept() {
      this.change_password();
      this.showDialog = false;
    },
    async accept(ev) {
      ev.preventDefault();
      if (this.$refs.form.validate()) {
        console.log(`CHANGE PASSWORD username: old password: ${this.oldPassword}, password: ${this.newPassword}`);
        //var res = await signIn(this.username, this.password)
        //if (res){
        //    if(res.code==='NotAuthorizedException'){
        //        this.show_invalid_password_message = true
        //    }else if(res.code==='UserNotFoundException'){
        //        this.show_user_not_found_message = true
        //    }
        //}
        var user = await this.$Amplify.Auth.currentAuthenticatedUser();
        this.$Amplify.Auth.changePassword(user, this.oldPassword, this.newPassword)
          .then(() => {
            this.reset_success = true;
            setTimeout(() => {
              this.showDialog = false;
            }, 2000);
          })
          .catch((err) => {
            if (err.code === "NotAuthorizedException") {
              this.show_invalid_password_message = true;
            } else if (err.code === "LimitExceededException") {
              this.show_limit_exceeded_message = true;
            } else {
              console.error("unexpected error changing password", err);
            }
          });
      }
    },
  },
  data: () => Object.assign(init_data(), { showDialog: false }),
};
</script>

<style lang="scss" scoped></style>
